import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "onboarding-settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_MessengerPrivacySettingsInline = _resolveComponent("MessengerPrivacySettingsInline")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    class: "admin-releases-modal",
    "is-open": _ctx.isOpen,
    onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('done')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Liga.Chat", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "onboarding-title" }, "Общайтесь внутри Liga.Chat", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "onboarding-text" }, " По умолчанию ваш профиль максимально приватный: вас не видно в поиске, и новые личные сообщения закрыты. ", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "onboarding-text onboarding-text--encrypt" }, " Личные, групповые и публичные чаты защищены клиентским шифрованием (E2E): текст сообщений на сервере хранится в зашифрованном виде, ключи расшифровки остаются на устройствах участников. Чат поддержки и системные уведомления для работы сервиса передаются без такого шифрования. ", -1)),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.privacy)
              ? (_openBlock(), _createBlock(_component_MessengerPrivacySettingsInline, {
                  key: 0,
                  privacy: _ctx.privacy,
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.privacy = $event))
                }, null, 8, ["privacy"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_ion_button, {
            class: "messenger-primary-btn",
            expand: "block",
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Сохранить", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ion_button, {
            class: "messenger-clear-btn",
            expand: "block",
            fill: "clear",
            onClick: _ctx.later
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Настроить позже", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open"]))
}